// On the client we want to check the system status every x seconds
// We do this to check for new notification or global system messages
export default function ({ store, $app, $activityRefresh }) {
  const statusRefresh = () => {
    store.dispatch('app/fetchStatus')
  }

  $activityRefresh.addCallback(statusRefresh)
}
